import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { AddPinComp } from "../../components/add-pin/add-pin.comp";
import { ContactInfoComp } from "../../components/contact-info/contact-info.comp";
import { EmailComp } from "../../components/email/email.comp";
import { LoadingComp } from "../../components/loading/loading.comp";
import { PaymentComp } from "../../components/payment/payment.comp";
import { PinComp } from "../../components/pin/pin.comp";
import { RegistrationInfoComp } from "../../components/registration-info/registration-info.comp";
import { StudentInfoListComp } from "../../components/student-info/student-info-list.comp";
import { SuccessComp } from "../../components/success/success.comp";
import { TermsComp } from "../../components/terms/terms.comp";
import { useData } from "../../libs/data/app-data.hook";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import {
  registrationKey,
  useRegistration,
} from "../../libs/registration/registration.hook";
import { RegistrationContainer } from "./styles/registration-container.style";

const payInit = false;

export const RegistrationView = () => {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const { fetching, all } = useData();
  const { registrationInfo, setRegistrationInfo, writeRegistrationInfo } =
    useRegistration();
  const isPcm = searchParams.get("pcm") === "1";
  const [step, setStep] = useState(
    payInit
      ? !isPcm
        ? RegistrationSteps.Payment
        : RegistrationSteps.Sucess
      : RegistrationSteps.Info
  );
  const currentEvent = useMemo(
    () => all?.find((entry) => entry.id === eventId),
    [eventId, all]
  );

  useEffect(() => {
    if (payInit && isPcm) {
      const selectedEventId = registrationInfo?.event || eventId;

      setRegistrationInfo({
        event: selectedEventId,
        payment: {
          ...(registrationInfo?.payment || {}),
          [selectedEventId || ""]: true,
        },
      });

      localStorage.removeItem(registrationKey);

      setTimeout(() => {
        writeRegistrationInfo();
      }, 100);
    } else {
      if (!registrationInfo.event) {
        setRegistrationInfo({
          event: eventId,
          payment: {
            ...(registrationInfo?.payment || {}),
            [eventId || ""]: true,
          },
        });
      } else {
        setRegistrationInfo({
          event: registrationInfo.event,
          payment: {
            ...(registrationInfo?.payment || {}),
            [registrationInfo.event || ""]: true,
          },
        });
      }
    }
  }, []);

  const changeStep = (step: RegistrationSteps) => {
    window.scrollTo(0, 0);
    setStep(step);
  };

  return (
    <RegistrationContainer>
      <h1>
        Registration for{" "}
        {step === RegistrationSteps.Sucess ||
        step === RegistrationSteps.AddPin ? (
          <strong>Summer Camp</strong>
        ) : (
          <strong>{currentEvent?.name ? `${currentEvent.name}` : ""}</strong>
        )}
      </h1>
      {step === RegistrationSteps.Info && currentEvent ? (
        <RegistrationInfoComp event={currentEvent} setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.Email ? (
        <EmailComp setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.Pin ? <PinComp setStep={changeStep} /> : null}
      {step === RegistrationSteps.ContactInfo ? (
        <ContactInfoComp setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.StudentInfo ? (
        <StudentInfoListComp currentEvent={currentEvent} setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.TermsAndConditions ? (
        <TermsComp setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.Payment ? (
        <PaymentComp event={currentEvent} setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.AddPin ? (
        <AddPinComp setStep={changeStep} />
      ) : null}
      {step === RegistrationSteps.Sucess ? (
        <SuccessComp setStep={changeStep} />
      ) : null}
      {fetching && <LoadingComp />}
    </RegistrationContainer>
  );
};
